import React, { useState } from "react";
import { Link } from "react-router-dom";

const AvatarUsuario = ({ usuario, size = 40 }) => {
  const [mostrarFallback, setMostrarFallback] = useState(false);

  const letra = usuario?.nombre?.[0]?.toUpperCase() ?? usuario?.email?.[0]?.toUpperCase() ?? "?";
  const estiloComun = `rounded-full flex items-center justify-center border border-white transition hover:brightness-90`;
  const estiloTexto = `text-black font-semibold`;
  const dimension = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size / 2.2}px`,
  };

  const fotoNombre = usuario?.foto?.replace(/^uploads\/fotos\//, "");
  const fotoUrl =
    fotoNombre && !mostrarFallback
      ? `${process.env.REACT_APP_API_URL}/api/foto/${fotoNombre}`
      : null;

  return (
    <Link to="/perfil" title="Ver perfil">
      {fotoUrl ? (
        <img
          src={fotoUrl}
          alt="Foto de perfil"
          className={`object-cover ${estiloComun}`}
          style={dimension}
          onError={() => setMostrarFallback(true)}
        />
      ) : (
        <div
          className={`bg-gray-300 ${estiloComun} ${estiloTexto}`}
          style={dimension}
        >
          {letra}
        </div>
      )}
    </Link>
  );
};

export default AvatarUsuario;
